import { render, staticRenderFns } from "./PhoneCallsSidebar.vue?vue&type=template&id=64fecf8c&scoped=true&"
import script from "./PhoneCallsSidebar.vue?vue&type=script&lang=js&"
export * from "./PhoneCallsSidebar.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PhoneCallsSidebar.vue?vue&type=style&index=1&id=64fecf8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fecf8c",
  null
  
)

export default component.exports